"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _default2 = exports.default = {
  name: 'wl-images',
  props: {
    src: {
      type: String,
      default: ''
    },
    autoUpdate: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'preview'
    },
    // type: {},
    images: {
      type: [Object, Array, String],
      default: ''
    },
    fit: {
      type: String,
      default: 'contain'
    },
    isFull: {
      type: Boolean,
      default: false
    },
    previewSrcList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      imageList: [],
      show: true,
      imageScr: ''
    };
  },
  computed: {
    imageSrcList: function imageSrcList() {
      var a = this.$$isNoEmpty(this.previewSrcList, 'array');
      var b = this.$$isNoEmpty(this.imageList, 'array');
      var c = a || b;
      var data = {};
      if (this.type === 'preview') Object.assign(data, {
        'preview-src-list': c.map(function (file) {
          var _ref, _file$src;
          return (_ref = (_file$src = file.src) !== null && _file$src !== void 0 ? _file$src : file.url) !== null && _ref !== void 0 ? _ref : typeof file === 'string' ? file : '';
        })
      });
      // if
      return this.$$isNoEmpty(c) ? data : {};
    },
    /* 可以删除？ */canDelete: function canDelete() {
      var _join, _this$$parent;
      return (_join = (0, _toConsumableArray2.default)(((_this$$parent = this.$parent) === null || _this$$parent === void 0 || (_this$$parent = _this$$parent.$el) === null || _this$$parent === void 0 ? void 0 : _this$$parent.classList) || []).join('')) === null || _join === void 0 ? void 0 : _join.includes('el-upload');
    }
  },
  watch: {
    images: {
      handler: function handler(nv /* , ov */) {
        this.getImage(nv);
      },
      deep: true
    },
    imageScr: {
      handler: function handler(nv /* , ov */) {
        this.imageList.length = 0;
        this.imageList.push(nv);
      },
      deep: true
    }
  },
  filters: {
    imgSrc: function imgSrc(img) {
      var _ref2, _img$src;
      return (_ref2 = (_img$src = img.src) !== null && _img$src !== void 0 ? _img$src : img.url) !== null && _ref2 !== void 0 ? _ref2 : typeof img === 'string' ? img : '';
    }
  },
  methods: {
    /** 获取图片数组
     * @description: 将单张或多张图片都装在数组里
     * @param { Array | String } nv 图片的数组或单张图片
     * @return { void }
     */
    getImage: function getImage(nv) {
      var a = [];
      if (Array.isArray(nv)) a = nv;else if (nv && (typeof nv === 'string' || (0, _typeof2.default)(nv) === 'object')) a = [nv];
      this.imageList = a;
      // this.imageList = a.map(s => typeof s === 'string' ? s : (s.src ?? s.url ?? ''))
    },
    /** 点击事件
     * @description: 将单张或多张图片都装在数组里
     * @param { String } src 图片链接
     * @param { Number } index 图片下标
     * @param { Object } e 点击事件
     * @return { void }
     */
    onclick: function onclick(src, index /* , e */) {
      var _this = this;
      this.type === 'preview' && this.$nextTick(function () {
        var a = _this.$refs['wl-images'][index];
        var b = a.$el.querySelector('.el-image-viewer__wrapper');
        b.style.cssText += ';display: none;';
      });
    },
    /** 点击放大图片
     * @description: 点击放大图片
     * @param { String } src 图片链接
     * @param { Number } index 图片下标
     * @param { Object } e 点击事件
     * @return { void }
     */
    onFull: function onFull(src, index, e) {
      var _this2 = this;
      e.preventDefault();
      e.stopPropagation();
      var a = this.$refs['wl-images'][index];
      this.$emit('update:isFull', true);
      this.$nextTick(function () {
        var b = a.$el.querySelector('.el-image-viewer__wrapper');
        b.style.cssText += ';display: block;';
        _this2.$nextTick(function () {
          var c = a.$el.querySelector('.el-image-viewer__close');
          c.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            b.style.cssText += ';display: none;';
            _this2.$nextTick(function () {
              _this2.$emit('update:isFull', false);
            });
          };
        });
      });
      this.$$listenersEmit('on-full', src, e);
    },
    /** 下载
     * @description: 下载
     * @param { Object } file 文件
     * @param { Number } index 文件下标
     * @param { Object } e 点击事件
     * @return { void }
     */
    onDownload: function onDownload(file /* , index, e */) {
      var _ref3, _file$src2;
      var url = (_ref3 = (_file$src2 = file.src) !== null && _file$src2 !== void 0 ? _file$src2 : file.url) !== null && _ref3 !== void 0 ? _ref3 : typeof file === 'string' ? file : '';
      var a = document.createElement('a');
      a.href = url;
      a.click();
    },
    /** 删除图片
     * @description: 删除图片
     * @param { String } src 图片链接
     * @param { Object } e 点击事件
     * @return { void }
     */
    onRemove: function onRemove(src, e) {
      this.$$listenersEmit('on-remove', src, e);
    },
    /** 图片加载成功
     * @param { String } src 图片链接
     * @param { Object } e 点击事件
     * @return { void }
     */
    load: function load(src, e) {
      // if (this.src && this.autoUpdate) {
      //   // 文件路径
      //   const a = this.imageScr.replace(/([^\\/]+)\.([^\\/]+)/, '')
      //   // 文件名
      //   const b = this.imageScr.replace(/(.*\/)*([^.]+).*/ig, '$2')
      //   // 后缀名
      //   const c = this.imageScr.replace(/.+\./, '')

      //   // b.search
      //   const getSrc = (i) => `${a}${b}@${i}x.${c}`

      //   let startIndex = 2
      //   if (b.search(/@([0-9])x/) > 0) {
      //     const i = parseInt(b.slice(b.search(/@([0-9])x/) + 1), 10)
      //     if (i && i > startIndex) startIndex = i
      //   }

      //   let errorNumber = 5
      //   const xhrFun = (i = 1) => {
      //     const xhr = new XMLHttpRequest()
      //     xhr.open('GET', getSrc(i), false)
      //     xhr.setRequestHeader('responseType', 'blob')
      //     xhr.onreadystatechange = () => {
      //       if (xhr.status === 200) {
      //         if (xhr.response[0] === '<') (errorNumber-- > 0) && xhrFun(i + 1)
      //         else this.imageScr = getSrc(i)
      //       }
      //     }
      //     xhr.send()
      //   }
      //   xhrFun(startIndex)
      // }

      this.$$listenersEmit('load', src, e);
    },
    /** 图片加载失败
     * @param { String } src 图片链接
     * @param { Object } e 点击事件
     * @return { void }
     */
    error: function error(src, e) {
      this.$emit('error', src, e);
    }
  },
  created: function created() {
    this.getImage(this.images);
    this.show = false;
    // if (this.src) this.imageScr = this.src
  },
  mounted: function mounted() {
    this.show = true;
  },
  updated: function updated() {
    // this.getImage(this.images)
  }
};